import { IconProps } from "./_types";

const RecordPlay = ({ size = 28, color = "white", ...other }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
    >
      <path
        d="M23.1161 16.0649C23.5038 15.8516 23.8228 15.5325 24.0361 15.1448C24.6571 14.0157 24.2452 12.5969 23.1161 11.9759L6.95781 3.08882C6.61331 2.89934 6.22651 2.79999 5.83333 2.79999C4.54467 2.79999 3.5 3.84466 3.5 5.13332V22.9074C3.5 23.3006 3.59935 23.6874 3.78883 24.0319C4.40986 25.161 5.82866 25.5729 6.95781 24.9519L23.1161 16.0649ZM5.54167 4.63165L22.5963 14.0133L5.54167 23.3942V4.63165Z"
        fill={color}
      />
    </svg>
  );
};

export default RecordPlay;
